import axios from 'axios';
import { getI18n } from 'react-i18next';
import { showInfoNotification, showErrorNotification } from './notifications';
import Constants from '../utils/Constants';
import _ from 'lodash';
import { createErrorMessage } from '../components/errors/Errors';
import { CANNOT_SEND_2FA_RESET_REQUEST } from '../components/errors/TwoFAErrors';

const onSuccess = (dispatch) => () => {
    dispatch(showInfoNotification(getI18n().t('request-2fa-reset.notification.request-received')));
};

const onError = (dispatch) => (error) => {
    const { response } = error;
    if (response && response.data && _.isArray(response.data)) {
        response.data.forEach((errObject) => {
            const message = createErrorMessage(errObject.code, errObject.params);
            dispatch(showErrorNotification(message));
        });
    } else {
        dispatch(showErrorNotification(createErrorMessage(CANNOT_SEND_2FA_RESET_REQUEST)));
    }
};

const request2FAResetToken = (userId, userEmail, userPassword) => (dispatch) => axios
    .post(Constants.LOST_2FA_TOKEN_PATH, { userId, userEmail, userPassword })
    .then(onSuccess(dispatch))
    .catch(onError(dispatch));

export default request2FAResetToken;
